<div #breadcrumbWrapper class="breadcrumb-wrapper">
    <span #breadcrumbTrail class="breadcrumb-trail">
        <span *ngFor="let breadcrumb of breadcrumbs" style="background-color: transparent;">
            <button *ngIf="!breadcrumb.isLastCrumb" mat-button (click)="appService.navigateTo(breadcrumb.route, breadcrumb.subdomain)">
                <ng-container *ngIf="breadcrumb.iconOverrideImagePath && breadcrumb.iconOverrideImagePath !== ''; else defaultIcon">
                    <img [src]="breadcrumb.iconOverrideImagePath" class="breadcrumb-icon-img" alt="icon" />
                </ng-container>
                <ng-template #defaultIcon>
                    <mat-icon class="material-symbols-outlined breadcrumb-icon">
                        {{ breadcrumb.iconName }}
                    </mat-icon>
                </ng-template>
                <span #textSpan *ngIf="!breadcrumb.isDisplayTextCollapsed">{{ breadcrumb.displayText }}</span>
            </button>
            <mat-icon *ngIf="!breadcrumb.isLastCrumb" class="crumb-separator">play_arrow</mat-icon>
            <button *ngIf="breadcrumb.isLastCrumb" mat-button (click)="appService.navigateTo(breadcrumb.route, breadcrumb.subdomain)">
                <ng-container *ngIf="breadcrumb.iconOverrideImagePath && breadcrumb.iconOverrideImagePath !== ''; else defaultIconLast">
                    <img [src]="breadcrumb.iconOverrideImagePath" class="breadcrumb-icon-img" alt="icon" />
                </ng-container>
                <ng-template #defaultIconLast>
                    <mat-icon class="material-symbols-outlined breadcrumb-icon">
                        {{ breadcrumb.iconName }}
                    </mat-icon>
                </ng-template>
                <span #textSpan>{{ breadcrumb.displayText }}</span>
            </button>
        </span>
    </span>
</div>
